import { ChangeBusinessDetails } from './ChangeBusinessDetails';

export class ChangeTagManager extends ChangeBusinessDetails {
  type: string = 'ChangeTagmanager';
}
